import { DashboardColour } from "../../Component/Common/Constants/Colour/dashboardColour";
import { Gender, RaceTypes } from "../../Component/Model/Enum/BEE123Enums";

export const pieChartLevelColour = (label: string): string => {
    switch (label) {
        // case window.BEE123.ComplianceLevel.Level_1.Text:
        //     return '#008080';
        // case window.BEE123.ComplianceLevel.Level_2.Text:
        //     return '#00cc99';
        // case window.BEE123.ComplianceLevel.Level_3.Text:
        //     return '#00f290';
        // case window.BEE123.ComplianceLevel.Level_4.Text:
        //     return '#00ff00';
        // case window.BEE123.ComplianceLevel.Level_5.Text:
        //     return '#deee12';
        // case window.BEE123.ComplianceLevel.Level_6.Text:
        //     return '#eddb23';
        // case window.BEE123.ComplianceLevel.Level_7.Text:
        //     return '#fdc935';
        // case window.BEE123.ComplianceLevel.Level_8.Text:
        //     return '#ff7619';
        case 'Non Compliant':
            return '#ff0000';
        case 'Not Rated':
            return 'whitesmoke';
        default:
            return '#000000';
    }
}

export const pieChartEmployeeHeadCountColour = (raceType: number, gender: number): string => {
    if (gender === Gender.Male && raceType === RaceTypes.African) {
        return DashboardColour.AfricanMale;
    }
    if (gender === Gender.Female && raceType === RaceTypes.African) {
        return DashboardColour.AfricanFemale;
    }

    if (gender === Gender.Male && raceType === RaceTypes.Coloured) {
        return DashboardColour.ColouredMale;
    }

    if (gender === Gender.Female && raceType === RaceTypes.Coloured) {
        return DashboardColour.ColouredFemale;
    }
    if (gender === Gender.Male && raceType === RaceTypes.Indian) {
        return DashboardColour.IndianMale;
    }

    if (gender === Gender.Female && raceType === RaceTypes.Indian) {
        return DashboardColour.IndianFemale;
    }

    if (gender === Gender.Male && raceType === RaceTypes.White) {
        return DashboardColour.WhiteMale;
    }

    if (gender === Gender.Female && raceType === RaceTypes.White) {
        return DashboardColour.WhiteFemale;
    }

    if (gender === Gender.Male && raceType === RaceTypes.NonRSA) {
        return DashboardColour.NonRSAMale;
    }

    if (gender === Gender.Female && raceType === RaceTypes.NonRSA) {
        return DashboardColour.NonRSAFemale;
    }

    return '#000000'
}



